import layoutsBtn from '../../images/docs/main-menu-Machete-edit.png';
import newLayoutBtn from '../../images/docs/machete-header-new-edit.png';
import newLayoutMenu from '../../images/docs/new-macheta-top-edit.png';
import exampleLayout from '../../images/docs/example-layout.png';
import layoutEdit from '../../images/docs/machete-list-edit.png';

export const meta = {
  slug: 'machete',
  title: 'Machete',
  description: 'Crearea și gestionarea machetelor pentru importul fișierelor Excel.',
  icon: 'table-cells',
  order: 6,
  related: ['generare-intrastat', 'firme'],
};

export const images = { layoutsBtn, newLayoutBtn, newLayoutMenu, exampleLayout, layoutEdit };

export const content = `
## Machete

Pentru a verifica orice informație legată de machete trebuie să fiți autentificat. Machetele sunt folosite de către program pentru a identifica din ce coloane trebuiesc luate datele din fișierul Excel importat. Câmpurile obligatorii sunt necesare pentru crearea unei declarații Intrastat valide.

### 1. Creare machete

Pentru a vizualiza machetele deja create și pentru a crea machete noi trebuie accesat meniul "Machete" <span class="dot">1</span>

::image[layoutsBtn]{alt="Butonul principal machete"}

Pentru a crea o machetă nouă va trebui să dați click pe butonul "Machetă nouă" <span class="dot">2</span>

::image[newLayoutBtn]{alt="Butonul machetă nouă"}

Veți fi întâmpinat de meniul pentru crearea machetelor.

::image[newLayoutMenu]{alt="Meniul de creare machetă"}

În acest meniu putem configura următoarele:

- <span class="dot">3</span> Denumirea machetei
- <span class="dot">4</span> Tipul (Livrări sau Achiziții)
- <span class="dot">5</span> Fișierul exemplu de unde se vor lua denumirile coloanelor
- <span class="dot">6</span> Firma pentru care este creată macheta. Această opțiune este utilă declaranților terți.

Odată ales fișierul Excel (.xlsx) vom putea selecta și fișa de lucru a fișierului Excel din care se vor lua denumirile coloanelor. Pentru a completa corect o machetă vor trebui completate toate coloanele evidențiate din formular. Exemplu completare:

::image[exampleLayout]{alt="Exemplu completare machetă"}

După cum se poate observa în exemplu, prima valoare pe care trebuie să o potrivim cu un cap de coloană din fișierul Excel importat este Cod vamal (HS). Putem alege orice coloană din tabel, important este ca aceasta să fie în aceeași poziție în fișierul încărcat de fiecare dată când se va folosi macheta (În exemplu, coloana selectată este în poziția nr 5 în fișierul Excel importat).

Odată ce coloana este selectată avem ocazia să introducem o valoare implicită pe care programul să o introducă în cazul în care aceasta lipsește din tabel. Aceasta poate rămâne liberă iar programul va evidenția lipsa valorilor obligatorii la generarea fișierului Intrastat.

Avem opțiunea să selectăm și valoarea "Nicio coloană". Dacă această opțiune este selectată, programul va crea o coloană în plus la generare în care va adăuga valoarea implicită setată de dvs. Cum se poate vedea în exemplu, valoarea "Greutate netă" are asignat "Nicio coloană" iar valoarea implicită este 10. Programul va crea astfel o coloană nouă la generare numită "Greutate netă" în care va umple toate rândurile cu valoarea "10".

În cazul în care este selectat "Nicio coloană" iar valoarea implicită este necompletată programul va crea o coloană nouă la generare cu rânduri goale. În cazul în care coloana este o valoare obligatorie (evidențiată cu albastru pe fundal în crearea machetei) atunci programul vă va anunța lipsa valorilor obligatorii la generarea fișierului intrastat.

Pentru a salva macheta după ce a fost completată corespunzător trebuie dat click pe butonul "Salvează" din josul machetei. În cazul în care nu se vrea salvarea machetei se poate ieși din configurarea machetei prin butonul "Anulează" din josul paginii sau butonul "Înapoi" din susul paginii.

### 2. Vizualizează, editează și șterge machete

Putem vizualiza machetele din listă în meniul "Machete".

::image[layoutEdit]{alt="Vizualizare machete"}

În această listă se pot vizualiza numele machetei <span class="dot">1</span>, firma pentru care este folosită <span class="dot">2</span>, tipul <span class="dot">3</span>, acțiunile pe care le putem accesa pentru a edita <span class="dot">4</span> sau a șterge <span class="dot">5</span> macheta și numărul de machete rămase pe care le putem crea cu abonamentul actual <span class="dot">6</span>.

Pentru a șterge o machetă trebuie doar să dăm click pe butonul "X" <span class="dot">5</span> roșu de la acțiunile machetei.

Pentru a edita o machetă din listă trebuie dat click pe butonul verde <span class="dot">4</span> de la acțiunile machetei. Se va deschide fereastra în care vom putea edita macheta selectată. Pentru mai multe detalii despre completarea corectă a machetei puteți vizualiza capitolul anterior. Odată modificată, macheta poate fi salvată prin apăsarea butonului verde de la finalul formularului de completare.

<p class="warn">În cazul în care aveți probleme cu o machetă la importarea fișierului Excel (pasul 8), încercați să ștergeți macheta folosită și să o recreați folosind ca referință fișierul Excel pe care doriți să-l încărcați. Nu uitați să salvați fișierul Excel după fiecare modificare făcută local. Programul nu poate vedea modificările dacă fișierul nu este salvat înainte de a fi încărcat. Recomandăm închiderea fișierului înainte de a îl încărca în program, astfel veți fi siguri că fișierul este salvat cu ultimele modificări.</p>
`;
